import React, { useContext, useState, useEffect } from 'react';

import { useTransportPrice } from '../../../../hooks/useTransportPrice' 
import { AppContext } from "../../../../providers/appProvider"
import ErrorModal from '../../../UI/ErrorModal/ErrorModal';
import ConfirmModal from '../../../UI/ConfirmModal/ConfirmModal';
import Pagination from '../../../UI/Pagination/Pagination';  
import TransportPriceDeleteModal from '../Delete/Delete';
import TransportPriceEditModal from '../Edit/Edit';
import AddTransportPrice from '../Add/Add';
import tbl from '../../../../assets/Style/Table.module.css'
import Select from "react-select"; 
import DateSelect from '../../../UI/Inputs/DateSelect';
import Excel from "../../../../assets/Icon/Excel";
import Remove from "../../../../assets/Icon/Remove";
 
import cl from './List.module.css'
import { selectStyle } from './selectStyle';
import AddOne from '../AddOne/Add';
import { useTranslation } from 'react-i18next';

const TransportPriceList = () => {
  const {t} = useTranslation();
  
  const { transportPriceService } = useTransportPrice(50, true);
  const {appState, app} = useContext(AppContext);
  const [currentTab, setCurrentTab] = useState(1)
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  // Confirmation modal states
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [archiveConfirmOpen, setArchiveConfirmOpen] = useState(false);

  const [locations, setLocations] = useState([]);
  const [receivers, setReceivers] = useState([]);
  const [senders, setSenders] = useState([]);
  const [providers, setProviders] = useState([]);

  useEffect(() => {
     const getCountryName = (countryId) => {
      const country =  appState.countries.find(country => country.id === countryId);
      return country ? country.name : '';
    };

     const locationCities = Array.from(new Set(appState.prices.map(item => item.location_city?.id))).map(id => {
      const city = appState.prices.find(item => item.location_city?.id === id)?.location_city;
      return { value: city?.id, label: `${getCountryName(city?.country_id)} ${city?.name}` };
    });
    setLocations(locationCities);

     const receiverCities = Array.from(new Set(appState.prices.map(item => item.reciever_city?.id))).map(id => {
      const city = appState.prices.find(item => item.reciever_city?.id === id)?.reciever_city;
      return { value: city?.id, label: `${getCountryName(city?.country_id)} ${city?.name}` };
    });
    setReceivers(receiverCities);

     const senderCities = Array.from(new Set(appState.prices.map(item => item.sender_city?.id))).map(id => {
      const city = appState.prices.find(item => item.sender_city?.id === id)?.sender_city;
      return { value: city?.id, label: `${getCountryName(city?.country_id)} ${city?.name}` };
    });
    setSenders(senderCities);

    // Get unique providers from prices (provider is a string)
    const uniqueProviders = Array.from(new Set(appState.prices.map(item => item.provider).filter(Boolean))).map(provider => ({
      value: provider,
      label: provider
    }));
    setProviders(uniqueProviders);

  }, [appState.prices, appState.countries]);

  // Update selectAll state when items change
  useEffect(() => {
    if (transportPriceService.items.length > 0) {
      setSelectAll(selectedItems.length === transportPriceService.items.length);
    } else {
      setSelectAll(false);
    }
  }, [selectedItems, transportPriceService.items.length]);

  // Clear selected items when tab changes
  useEffect(() => {
    setSelectedItems([]);
    setSelectAll(false);
  }, [currentTab]);

  // Clear selected items when filter changes (except page changes)
  useEffect(() => {
    setSelectedItems([]);
    setSelectAll(false);
  }, [
    transportPriceService.filter.website_id,
    transportPriceService.filter.sender_city_id,
    transportPriceService.filter.reciever_city_id,
    transportPriceService.filter.location_city_id,
    transportPriceService.filter.provider,
    transportPriceService.filter.company_price,
    transportPriceService.filter.internal_price,
    transportPriceService.filter.created_at_min,
    transportPriceService.filter.created_at_max,
    transportPriceService.filter.is_active
  ]);



  const handleInputChange = (event) => {
    const { name, value } = event.target;
  
 
    const intValue = parseInt(value, 10);
  
     if (!isNaN(intValue)) {
      transportPriceService.setFilter({
        ...transportPriceService.filter,
        [name]: intValue
      });
    } else {
      transportPriceService.setFilter({
        ...transportPriceService.filter,
        [name]: null
      });
    }
  };

  const customFilers = [
    { value: 1, label: t('Active') },
    { value: 2, label: t('Archive') },
  ];

  const websites = appState.websites.map((website) => ({ value: website.id, label: website.name }));

  const onChangeTab = (val) => {
    setCurrentTab(val.value)
    switch (val.value) {
      case 1:
        transportPriceService.setFilter(prevState => ({
          ...prevState,
          is_active: true,
        }));
        break;
      case 2:
        transportPriceService.setFilter(prevState => ({
          ...prevState,
          is_active: false,
        }));
        break;
      default:
        transportPriceService.setFilter(prevState => ({
          ...prevState,
          is_active: true,
        }));
    }
  }


  const hanldeCreatedAtMin = (date) => {

    transportPriceService.setFilter({ 
      ...transportPriceService.filter,
      created_at_min: date ? date : "",
    });
  };

  const hanldeCreatedAtMax = (date) => { 
    transportPriceService.setFilter({
      ...transportPriceService.filter,
      created_at_max: date ? date : "",
    });
  };


  const formatDate = (dateString) => {
      const createdAtDate = new Date(dateString);

      const months = [
        t("Jan"),
        t("Feb"),
        t("Mar"),
        t("Apr"),
        t("May"),
        t("Jun"),
        t("Jul"),
        t("Aug"),
        t("Sep"),
        t("Oct"),
        t("Nov"),
        t("Dec"),
      ];

      const day = createdAtDate.getDate();
      const month = months[createdAtDate.getMonth()];
      const year = createdAtDate.getFullYear();
      const hours = createdAtDate.getHours().toString().padStart(2, '0');  
      const minutes = createdAtDate.getMinutes().toString().padStart(2, '0');  

      return `${day} ${month} ${year} ${hours}:${minutes}`; 
  };


  const downloadExcel = () => {
    transportPriceService.downloadExcel()
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);
    if (isChecked) {
      setSelectedItems(transportPriceService.items.map(item => item.id));
    } else {
      setSelectedItems([]);
    }
  };

  const handleSelectItem = (id) => {
    const isSelected = selectedItems.includes(id);
    if (isSelected) {
      setSelectedItems(selectedItems.filter(item => item !== id));
    } else {
      setSelectedItems([...selectedItems, id]);
    }
  };

  const handleMassDelete = async () => {
    if (selectedItems.length === 0) {
      app.setError(t('Please select items to delete'));
      return;
    }
    
    setDeleteConfirmOpen(true);
  };

  const confirmMassDelete = async () => {
    try {
      await transportPriceService.massDelete(selectedItems);
      setSelectedItems([]);
      setSelectAll(false);
      setDeleteConfirmOpen(false);
      app.setOk(t('Items deleted successfully'));
    } catch (error) {
      console.error('Mass delete error:', error);
      setDeleteConfirmOpen(false);
      app.setError(t('Error deleting items'));
    }
  };

  const handleMassArchive = async () => {
    if (selectedItems.length === 0) {
      app.setError(t('Please select items to archive'));
      return;
    }
    
    setArchiveConfirmOpen(true);
  };

  const confirmMassArchive = async () => {
    try {
      await transportPriceService.massArchive(selectedItems);
      setSelectedItems([]);
      setSelectAll(false);
      setArchiveConfirmOpen(false);
      app.setOk(t('Items archived successfully'));
    } catch (error) {
      console.error('Mass archive error:', error);
      setArchiveConfirmOpen(false);
      app.setError(t('Error archiving items'));
    }
  };



  return <div>

    <div className={ cl.headMain }> 
        <h1>{t('Transportation')}</h1>  

        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>

 
          <span  onClick={downloadExcel} className={cl.exelBtn}>
              <span className={cl.icon} > <Excel /></span>
              {t('Export')}
            </span> 

           
          { app.hasPermission("TRANSPORT_PRICE_UPLOAD") && 
          <>
            <AddTransportPrice transportPriceService={transportPriceService}  /> 
            <AddOne transportPriceService={transportPriceService}  /> 
            </>
          }
          </div>
 
  
      </div>
            <div className={cl.massActions}>
            <button 
              className={cl.massActionBtn} 
              onClick={handleMassDelete}
              disabled={selectedItems.length === 0}
            >
              {t('Delete')}
            </button>
            <button 
              className={cl.massActionBtn} 
              onClick={handleMassArchive}
              disabled={selectedItems.length === 0}
            >
              {t('Archive')}
            </button>
          </div>
    <div className={cl.searchBox}> 
   
      <div className={cl.col}  style={{ borderRight: '1px solid var(--border-color)', width: '35%' }}>  
        <div className={cl.inBoxDate}>
          <div className={cl.dateGroup}>
            <DateSelect
              defDate={""}
              onChange={hanldeCreatedAtMin}
              placeholderText={t('From')}
              popperClassName={cl.dataContainer}
              wrapperClassName={cl.dataContainer}
              className={cl.input}
              isClearable
            />
          </div>

        </div>
      </div>
      
      <div className={cl.col}  style={{ borderRight: '1px solid var(--border-color)', width: '35%' }}>  
        <div className={cl.inBoxDate}> 
          <div className={cl.dateGroup}>
            <DateSelect
              defDate={""}
              onChange={hanldeCreatedAtMax}
              placeholderText={t('To')}
              popperClassName={cl.dataContainer}
              wrapperClassName={cl.dataContainer}
              className={cl.input}
              isClearable
            />
          </div> 
        </div>
      </div>

      <div className={cl.col} style={{ width: '30%' }}> 
 
        <Select
          styles={selectStyle}
          options={customFilers}
          value={customFilers.find(option => option.value === currentTab)}
          onChange={onChangeTab}
        />

      </div>
    </div>

    <div className={tbl.table + ' ' + cl.table} style={{ height: 'calc(100vh - 158px)', background: 'white' }}> 
      <table>
          <thead>
              <tr>
                  <th className={cl.checkbox}>
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                    />
                  </th>
                  <th className={cl.id} >#</th>
                  <th className={cl.pad0}>
                      <Select
                        styles={selectStyle}
                        options={websites}
                        value={websites.find(option => option.value === transportPriceService.filter.website_id)}
                        onChange={(selectedOption) => {
                          transportPriceService.setFilter(prevState => ({
                            ...prevState,
                            website_id: selectedOption ? selectedOption.value : 0,
                          }));
                        }}
                        isClearable
                        placeholder={t('Website')}
                      /> 

                  </th>
                  <th className={cl.pad0}>
                    <Select
                        styles={selectStyle}
                        options={senders}
                        value={senders.find(option => option.value === transportPriceService.filter.sender_city_id)}
                        onChange={(selectedOption) => {
                          transportPriceService.setFilter(prevState => ({
                            ...prevState,
                            sender_city_id: selectedOption ? selectedOption.value : 0,
                          }));
                        }}
                        isClearable
                        placeholder={t('Loading')} 
                      /> 
                  </th>
                  <th className={cl.pad0}>
                    <Select
                        styles={selectStyle}
                        options={receivers}
                        value={receivers.find(option => option.value === transportPriceService.filter.reciever_city_id)}
                        onChange={(selectedOption) => {
                          transportPriceService.setFilter(prevState => ({
                            ...prevState,
                            reciever_city_id: selectedOption ? selectedOption.value : 0,
                          }));
                        }}
                        isClearable
                        placeholder={t('ReceivingPort')}
                      /> 
                  </th>

                  <th className={cl.pad0}>
                      <Select
                        styles={selectStyle}
                        options={locations}
                        value={locations.find(option => option.value === transportPriceService.filter.location_city_id)}
                        onChange={(selectedOption) => {
                          transportPriceService.setFilter(prevState => ({
                            ...prevState,
                            location_city_id: selectedOption ? selectedOption.value : 0,
                          }));
                        }}
                        isClearable
                        placeholder={t('Location')}
                      /> 
                  </th>
                  {app.hasPermission("PROVAIDER_VIEW") && (    
                      <th className={cl.pad0}>
                          <Select
                            styles={selectStyle}
                            options={providers}
                            value={providers.find(option => option.value === transportPriceService.filter.provider)}
                            onChange={(selectedOption) => {
                              transportPriceService.setFilter(prevState => ({
                                ...prevState,
                                provider: selectedOption ? selectedOption.value : "",
                              }));
                            }}
                            isClearable
                            placeholder={t('Provider')}
                          /> 
                      </th>
                    )}
                  
                  <th className={cl.pad0}>
                    <input
                      name="company_price"
                      className={cl.input}
                      placeholder={t('ContainerPrice')}
                      value={transportPriceService.filter.company_price}
                      onChange={handleInputChange}

                    />
                  </th>
                  <th className={cl.pad0}>
                  <input
                      name="internal_price"
                      className={cl.input}
                      placeholder={t('InternalTransportation')}
                      value={transportPriceService.filter.internal_price}
                      onChange={handleInputChange}

                    />
                    </th>
                  <th>{t('SalersPrice')}</th>
                  <th>{t('CreatedAt')}</th>
                  <th>{t('UpdatedAt')}</th>
                  <th></th> 
              </tr>
          </thead>
          <tbody>
            {transportPriceService.items.map((transportPrice) =>
                <tr key={transportPrice.id} >
                  <td className={cl.checkbox}>
                    <input
                      type="checkbox"
                      checked={selectedItems.includes(transportPrice.id)}
                      onChange={() => handleSelectItem(transportPrice.id)}
                    />
                  </td>
                  <td className={cl.id} >{transportPrice.id}</td> 
                  <td>  {transportPrice.website?.name || ''} </td>
                  <td>{transportPrice.sender_country.name}  {transportPrice.sender_city?.name}  </td>  
                  <td>{transportPrice.reciever_country.name}  {transportPrice.reciever_city?.name} </td> 
                  <td>
  {transportPrice.location_country?.name || ''} {transportPrice.location_city?.name || ''}
</td>
                  {app.hasPermission("PROVAIDER_VIEW") && (
                    <td>{transportPrice.provider || ''}</td>  
                  )}

                  <td>{transportPrice.company_price} $</td>
                  <td>{transportPrice.internal_price} $</td>
                  <td>{transportPrice.company_price + transportPrice.internal_price + transportPrice.website.company_win} $</td>

                  <td> {formatDate(transportPrice.created_at)}</td>
                  <td> {formatDate(transportPrice.update_at)}</td>

                  <td className={ cl.btntbl }>
                    <div className={ cl.btns }>
                    { app.hasPermission("TRANSPORT_PRICE_EDIT") && 
                       <> 
                      <TransportPriceEditModal transportPriceService={transportPriceService} defaultTransportPrice={transportPrice} />   
                      <TransportPriceDeleteModal transportPriceService={transportPriceService} defaultTransportPrice={transportPrice} /> 
                      </>
                     }
                    </div>
                  </td>
                </tr>  
              )}
          </tbody>
      </table>
 
    </div>



   {appState.error && <ErrorModal message={appState.error} onClose={() => app.clearError(false)} />}

   {/* Confirmation Modals */}
   <ConfirmModal
     isOpen={deleteConfirmOpen}
     onClose={() => setDeleteConfirmOpen(false)}
     onConfirm={confirmMassDelete}
     title={t('Delete')}
     message={t('Are you sure you want to delete selected items?')}
     confirmText={t('YesIdo')}
     cancelText={t('Cancel')}
     icon={<Remove />}
   />

   <ConfirmModal
     isOpen={archiveConfirmOpen}
     onClose={() => setArchiveConfirmOpen(false)}
     onConfirm={confirmMassArchive}
     title={t('Archive')}
     message={t('Are you sure you want to archive selected items?')}
     confirmText={t('YesIdo')}
     cancelText={t('Cancel')}
     icon={<Remove />}
   />

    <Pagination 
      total={transportPriceService.total} 
        perPage={transportPriceService.filter.limit} 
        current={transportPriceService.filter.page} 
        paginate={(page) => {
            transportPriceService.setFilter({
            ...transportPriceService.filter,
            page: page,
          });
        }}
        setLimit={(limit) => {
            transportPriceService.setFilter({
            ...transportPriceService.filter,
            limit: limit,
          });
        }}
    />
  </div>;
}

export default TransportPriceList;